import { render, staticRenderFns } from "./LoadMoreButton.vue?vue&type=template&id=5ffd3b54&scoped=true&"
import script from "./LoadMoreButton.vue?vue&type=script&lang=js&"
export * from "./LoadMoreButton.vue?vue&type=script&lang=js&"
import style0 from "./LoadMoreButton.vue?vue&type=style&index=0&id=5ffd3b54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd3b54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
